import React from "react";
import {FormattedHTMLMessage} from "react-intl";
import classnames from 'classnames';

const GuideAssistantContent = ({className, content, id}) => {
  const cssBEM = 'guideAssistantContent';
  const classes = classnames(cssBEM, className);

  return (
    <div className={classes}>
      { content || <FormattedHTMLMessage id={`${id}.content`} /> }
    </div>
  );
};

export default GuideAssistantContent;
